import NodeContentApiSerializer from 'rise-ui/serializers/apis/rise-api/content/node.js';

export default class FileGallerySerializer extends NodeContentApiSerializer {
  extractAttributes(modelClass, resourceHash) {
    const attrs = super.extractAttributes(...arguments);
    const fileData = resourceHash.relationships?.field_file?.data;
    if (fileData) {
      attrs.fileMeta = {};
      attrs.fileOrder = [];
      fileData.forEach((fd, index) => {
        attrs.fileMeta[fd.id] = {
          index,
          id: fd.id,
          description: fd.meta?.description,
        };
        attrs.fileOrder.push(fd.id);
      });
    }
    return attrs;
  }
  keyForRelationship(key) {
    key = super.keyForRelationship(key);
    const mapOrDefault = (value, map, defaultValue) => {
      const isMap = map instanceof Map;
      let newValue;
      return map && (isMap ? map.has(value) : value in map)
        && (newValue = (isMap ? map.get(map) : map[value]))
        ? newValue : defaultValue;
    };
    return mapOrDefault(key, {
      files: 'field_file',
    }, super.keyForRelationship(key));
  }
}
